'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = _defineProperty({}, _ActionTypes2.default.SEND_TYPING_STATE, function (action, getState, dispatch, client) {
  var currentChannel = getState().currentChannel;
  var typingState = action.payload;
  var canPublishMessage = (0, _clientSelectors.getCanPublishMessage)(getState());

  if (client && currentChannel !== null && canPublishMessage) {
    client.setState({
      channels: [currentChannel],
      state: {
        timestamp: _I18n2.default.moment().valueOf(),
        whosTyping: typingState.toJS()
      }
    });
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/pubNubHandlers/stateHandlers.js
// module id = 501
// module chunks = 0